import { i18nKeys } from '@/src/utils/i18n.utils';
import { Box, Button, Modal, SpaceBetween } from '@amzn/awsui-components-react';
import React from 'react';
import { useTranslation } from 'react-i18next';

interface AlertModalProps {
  value: boolean;
  setValue: React.Dispatch<React.SetStateAction<boolean>>;
}

const AlertModal: React.FC<AlertModalProps> = ({ value, setValue }) => {
  const { t } = useTranslation();
  const handleModal = () => setValue(!value);

  return (
    <Modal
      onDismiss={handleModal}
      visible={value}
      header={
        <SpaceBetween size="xs" direction="horizontal" alignItems="center">
          <img src="/assets/aws-jam-logo-70x70.png" alt={t(i18nKeys.header.logo.title)} style={{ width: '40px' }} />
          <Box variant="h2">{t(i18nKeys.myJams.challenges.common.alert)}</Box>
        </SpaceBetween>
      }
      footer={
        <Box float="right" margin={{ vertical: 'xs' }}>
          <SpaceBetween direction="horizontal" size="xs">
            <Button variant="primary" onClick={handleModal}>
              {t(i18nKeys.myJams.challenges.common.ok)}
            </Button>
          </SpaceBetween>
        </Box>
      }
      closeAriaLabel={t(i18nKeys.general.closeModal)}
    >
      <Box>{t(i18nKeys.myJams.challenges.details.solveUsing.buttons.restartChallenge.subtitle)}</Box>
    </Modal>
  );
};

export default AlertModal;
